import React from 'react';
import styled, { useTheme } from 'styled-components';
import { motion } from 'framer-motion';
import { LoadingContainer, LoadingContent } from '../../styles/ChatStyles';

const LoadingSpinner = styled(motion.div)`
  width: 40px;
  height: 40px;
  border: 3px solid ${props => props.theme.colors.border};
  border-top: 3px solid ${props => props.theme.colors.primary};
  border-radius: 50%;
  margin: 0 auto 16px;
`;

const LoadingText = styled(motion.p)`
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSize.base};
  font-weight: 600;
  margin: 0;
  text-align: center;
  opacity: 1;
  text-shadow: 0 1px 2px rgba(0,0,0,0.1);
`;

const LoadingDots = styled(motion.span)`
  display: inline-block;
`;

const spinTransition = {
  duration: 1,
  ease: "linear",
  repeat: Infinity,
};

const textVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { 
    opacity: 0.8, 
    y: 0,
    transition: {
      delay: 0.2,
      duration: 0.5
    }
  }
};

const dotsVariants = {
  animate: {
    transition: {
      staggerChildren: 0.2,
      repeat: Infinity,
      repeatType: "loop",
      repeatDelay: 0.5
    }
  }
};

const dotVariants = {
  animate: {
    opacity: [0, 1, 0],
    transition: {
      duration: 0.8,
      ease: "easeInOut"
    }
  }
};

const LoadingScreen = () => {
  const theme = useTheme();
  
  return (
    <LoadingContainer theme={theme}>
      <LoadingContent theme={theme}>
        <LoadingSpinner
          theme={theme}
          animate={{ rotate: 360 }}
          transition={spinTransition}
        />
        <LoadingText
          theme={theme}
          variants={textVariants}
          initial="initial"
          animate="animate"
        >
          Đang tải cấu hình trò chuyện
          <LoadingDots
            variants={dotsVariants}
            animate="animate"
          >
            {['.', '.', '.'].map((dot, index) => (
              <motion.span
                key={index}
                variants={dotVariants}
                transition={{ delay: index * 0.2 }}
              >
                {dot}
              </motion.span>
            ))}
          </LoadingDots>
        </LoadingText>
      </LoadingContent>
    </LoadingContainer>
  );
};

export default LoadingScreen;